<template>
  <p-container>
    <h2 class="mb-4">
      {{ $t('core.page.processes.page.title') }}
    </h2>
    <p-col sm12 md6 lg4>
      <p-card fill-height>
        <h5 class="mb-2">
          {{ $t('core.page.processes.title.processPendingIntegrationCalls') }}
        </h5>
        <p-form>
          <p-row column>
            <p-select
              v-model="model.sourceAppSystemId"
              item-display="key"
              :label="$t('core.page.processes.label.appSystem')"
              :items="appSystems"
            ></p-select>
            <p-text-field
              v-model="model.integrationTaskId"
              :label="$t('core.page.processes.label.integrationTaskId')"
            ></p-text-field>
            <p-number-field
              v-model="model.itemsToBeProcessed"
              :label="$t('core.page.processes.label.itemsToBeProcessed')"
            ></p-number-field>
          </p-row>
        </p-form>
        <p-request-alert v-model="requestError"></p-request-alert>
        <p-row justify-end>
          <p-button :disabled="isLoading" :loading="isLoading" @click="processPendingIntegrationCalls()">
            {{ $t('core.page.processes.button.processPendingIntegrationCalls') }}
          </p-button>
        </p-row>
      </p-card>
    </p-col>
    <br>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import AppSystemResourceViewModel from '../../../../services/v1/viewModel/resource/AppSystemResourceViewModel';
  import ProcessPendingIntegrationCallsRequestViewModel from '../../../../services/v1/viewModel/resource/ProcessPendingIntegrationCallsRequestViewModel';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      requestError: undefined as any,
      isLoading: false,
      model: new ProcessPendingIntegrationCallsRequestViewModel(),
      appSystems: [] as AppSystemResourceViewModel[],
    }),
    computed: {
    },
    mounted() {
      this.populateData();
    },
    methods: {
      async populateData() {
        const response = await this.$service.v1.api.core.appSystem.getAppSystem();
        this.appSystems = response.items;
      },
      async processPendingIntegrationCalls() {
        this.isLoading = true;
        try {
          await this.$service.api.core.processes.processPendingIntegrationCalls(this.model);
        } catch (error: any) {
          this.requestError = error;
          Vue.$log.error(error);
        }
        this.isLoading = false;
      },
    },
  });
</script>
